import React from 'react';
import { painPoints } from '../data/landing';
export function PainSection() {
  return <section className="bg-parchment py-14 md:py-28" data-id="element-111" data-mp="38ygfc8hvsmmc">
      <div className="mx-auto max-w-3xl px-5 text-center md:px-8" data-id="element-112" data-mp="38x5ae5cp98tn">
        <h2 className="font-serif text-[1.9rem] font-semibold leading-tight text-ink sm:text-4xl md:text-5xl" data-id="element-113" data-mp="2ux41q3q70x3m">
          ¿Sentís que necesitás acercarte más a Dios, pero no sabés por dónde empezar?
        </h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-4 text-[15px] leading-relaxed text-ink/80 sm:text-lg md:mt-8 md:space-y-5" data-id="element-114" data-mp="2l7kiuy2hd38r">
          <p data-id="element-115" data-mp="2q0vq30b7fm17">Hay momentos en los que necesitamos detenernos, hacer silencio y volver a escuchar la Palabra.</p>
          <p data-id="element-116" data-mp="2g996afkswemu">
            A veces leemos un Salmo, pero nos cuesta comprender todo lo que nos quiere transmitir. Otras veces, queremos
            dedicar más tiempo a nuestra fe, pero terminamos postergándolo entre las obligaciones de todos los días.
          </p>
          <p data-id="element-117" data-mp="277rsx4ys2r1u">
            Y cuando atravesamos momentos de incertidumbre, preocupación o tristeza, encontrar palabras que nos ayuden a
            reflexionar puede convertirse en algo profundamente valioso.
          </p>
        </div>
        <p className="mx-auto mt-8 max-w-2xl font-serif text-xl italic leading-snug text-gold-dark sm:text-2xl md:mt-10 md:text-3xl" data-id="element-118" data-mp="5fsr0p8luzeb">
          Tu relación con Dios también necesita tiempo, atención y un corazón dispuesto a escuchar.
        </p>
      </div>

      <div className="mx-auto mt-14 max-w-5xl px-5 md:mt-20 md:px-8" data-id="element-119" data-mp="38x2kt1giqv1y">
        <h3 className="text-center font-serif text-2xl font-semibold text-ink sm:text-3xl md:text-4xl" data-id="element-120" data-mp="33y7vrhryka9e">
          ¿Te identificás con alguna de estas situaciones?
        </h3>
        <ul className="mt-8 grid gap-px overflow-hidden rounded-2xl border border-line bg-line md:mt-12 md:grid-cols-2" data-id="element-121" data-mp="3dvw08zfd8w4r">
          {painPoints.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex gap-4 bg-cream p-5 sm:gap-5 sm:p-7 md:p-9" data-id="element-122" data-mp="2l6yjj0qsz7e4">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gold-light sm:h-11 sm:w-11" data-id="element-123" data-mp="2l549ihh2kzot">
                <Icon className="h-4 w-4 text-gold-dark sm:h-5 sm:w-5" aria-hidden="true" data-id="element-124" data-mp="u2n57cf2ig3q" />
              </span>
              <div data-id="element-125" data-mp="ytdciv720t12">
                <h4 className="font-serif text-xl font-semibold leading-tight text-ink sm:text-2xl" data-id="element-126" data-mp="yuwucq8czc4y">{title}</h4>
                <p className="mt-1.5 text-sm leading-relaxed text-muted sm:mt-2 sm:text-base" data-id="element-127" data-mp="12up8digiuahp">{text}</p>
              </div>
            </li>)}
        </ul>
        <p className="mx-auto mt-8 max-w-2xl text-center text-[15px] leading-relaxed text-ink/80 sm:text-lg md:mt-12" data-id="element-128" data-mp="b399oq1owxb4">
          <strong className="text-ink" data-id="element-129" data-mp="f4utywgk0dvc">No necesitás saberlo todo para empezar.</strong> A veces, el primer paso es
          simplemente abrir la Palabra y dedicarle unos minutos de tu día.
        </p>
      </div>
    </section>;
}